<template>
     <v-form
          ref="form"
          v-model="ui.valid"
          lazy-validation
          @submit.prevent="send()"
     >
          <v-row>
               <v-col cols="12 mb-8">
                    <div class="d-flex align-center">
                         <v-btn
                              fab
                              text
                              small
                              class="elevation-2 mr-3"
                              @click="$router.go(-1)"
                         >
                              <v-icon>
                                   mdi-arrow-left
                              </v-icon>
                         </v-btn>
                         <h1>
                              Recuperar contraseña
                         </h1>
                    </div>

                    <span>
                         ¿Ya tiene cuenta?
                         <router-link :to="{ name: 'Login' }">
                              Iniciar sesión
                         </router-link>
                    </span>
               </v-col>

               <template v-if="!ui.success">
                    <v-col cols="12" class="pt-0">
                         Ingrese la dirección de correo electrónico asociada a
                         su cuenta.
                    </v-col>

                    <v-col cols="12" class="pb-0 ">
                         <v-text-field
                              clearable
                              autocomplete="off"
                              outlined
                              type="email"
                              label="Correo electrónico"
                              :rules="[v.required, v.email]"
                              v-model="layout.email"
                         ></v-text-field>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                         <v-btn
                              color="primary"
                              large
                              @click="send()"
                              :disabled="!ui.valid"
                              :loading="ui.sending"
                              :block="$vuetify.breakpoint.smAndDown"
                         >
                              enviar
                         </v-btn>
                    </v-col>
               </template>

               <template v-else>
                    <v-col cols="12" class="pb-0 pt-0">
                         <v-alert type="success" text prominent>
                              <div class="d-flex flex-column pl-3">
                                   <h3>
                                        ¡Muy bien!
                                   </h3>

                                   <p>
                                        ¡Hemos enviado un correo electrónico con
                                        el siguiente paso para actualizar tu
                                        contraseña!
                                   </p>

                                   <small>
                                        Revise su bandeja de entrada y la
                                        carpeta de SPAM.
                                   </small>
                              </div>
                         </v-alert>
                    </v-col>

                    <v-col cols="12">
                         Usted cuenta con 1 hora para actualizar su contraseña a
                         partir del envió de esta solicitud.
                    </v-col>
               </template>
          </v-row>
     </v-form>
</template>

<script>
import { EventBus } from "@/main";
import axios from "axios";
import Validations from "@/../../GeneralComponents/Validations";

export default {
     data() {
          return {
               v: Validations,

               layout: {
                    email: null,
               },

               ui: {
                    valid: true,
                    sending: false,
                    success: false,
                    showPassword: false,
               },
          };
     },

     methods: {
          async send() {
               if (this.$refs.form.validate()) {
                    this.ui.sending = true;
                    try {
                         let response = await axios.post(
                              `${process.env.VUE_APP_API_SERVER}/password/email`,
                              this.layout
                         );

                         this.ui.success = true;
                    } catch (error) {
                         EventBus.$emit("Error", {
                              error: error,
                              errorsShow: true,
                         });
                    } finally {
                         this.ui.sending = false;
                    }
               }
          },
     },
};
</script>

<style lang="css" scoped></style>
